module.exports = __webpack_public_path__ + "img/MUSA-25.afc0da72.jpg";